import { L1EventForm } from "./form";

export function L1EventsNew() {
  return <L1EventForm isNew />;
}
